import { Error } from 'src/presentation/pages'

export const makeError = () => <Error />
